module.exports = __webpack_public_path__ + "static/ic-josip-3017399a6f585b22c2ec9e6922604ccc.png";